<div class="chat-history-list" *ngIf="groupedChats$ | async as groupedChats">
  @if (loading) {
    <p-skeleton width="8rem" height="1.5rem" styleClass="chat-history-subtitle"/>
    <div class="chat-history-sublist">
      <p-skeleton height="2.25rem"></p-skeleton>
      <p-skeleton height="2.25rem"></p-skeleton>
    </div>
    <p-skeleton width="8rem" height="1.5rem" styleClass="chat-history-subtitle"/>
    <div class="chat-history-sublist">
      <p-skeleton height="2.25rem"></p-skeleton>
      <p-skeleton height="2.25rem"></p-skeleton>
    </div>
  } @else {
    <div *ngFor="let group of groupedChats | keyvalue:customSort">
      <h3 class="chat-history-subtitle">{{ group.key }}</h3>
      <div class="chat-history-sublist">
        <icbc-sidebar-chat-history-item [chatItem]="chat" *ngFor="let chat of group.value">
        </icbc-sidebar-chat-history-item>
      </div>
    </div>
  }
</div>
